<div class="u-height-100" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <ng-container [ngSwitch]="viewMode">
      <ng-container
        *ngSwitchCase="viewModes.add_roles"
        [ngTemplateOutlet]="addForm"
      ></ng-container>
      <ng-container
        *ngSwitchCase="viewModes.review"
        [ngTemplateOutlet]="review"
      ></ng-container>
      <ng-container
        *ngSwitchCase="viewModes.summary"
        [ngTemplateOutlet]="summary"
      ></ng-container>
      <ng-container
        *ngSwitchCase="viewModes.success"
        [ngTemplateOutlet]="success"
      ></ng-container>
    </ng-container>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
  >
    <button
      mat-button
      type="button"
      [disabled]="isLoading"
      (click)="closeDrawer()"
      i18n="@@global.close"
    >
      Close
    </button>
    <button
      *ngIf="viewMode === viewModes.add_roles"
      mat-raised-button
      type="button"
      color="primary"
      [disabled]="!roles.valid"
      (click)="reviewRoles()"
      i18n="@@hubConfigRolesBulkAddDrawer.reviewRoles"
    >
      Review roles
    </button>
    <button
      *ngIf="viewMode === viewModes.summary"
      mat-button
      type="button"
      color="primary"
      (click)="retry()"
      i18n="@@global.retry"
    >
      Retry
    </button>
    <button
      *ngIf="viewMode === viewModes.review"
      [disabled]="isLoading"
      mat-raised-button
      type="button"
      color="primary"
      (click)="saveRoles()"
    >
      <ng-container i18n="@@hubConfigRolesBulkAddDrawer.saveRoles">
        Save roles</ng-container
      >
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
    <ng-container *ngIf="isLoading">
      <p class="color-grey-300">
        (<ng-container i18n="@@global.progress">Progress</ng-container>:
        {{ completedProgress }}/{{ getRoleControls()?.value?.length }})
      </p>
    </ng-container>
  </div>
</div>
<ng-template #addForm>
  <form class="u-marginBottom-16">
    <p
      class="u-marginBottom-8"
      i18n="@@hubConfigRolesBulkAddDrawer.description"
    >
      Enter new options separated by a new line. To bulk add items, create your
      list in your text editor and paste it in the text below.
    </p>
    <mat-form-field class="mat-form-field-width-100">
      <textarea
        matInput
        cdkTextareaAutosize
        [cdkAutosizeMinRows]="10"
        [cdkAutosizeMaxRows]="15"
        [formControl]="roles"
        placeholder="Example item 1&#10;Example item 2&#10;Example item 3"
        autocomplete="off"
        required="true"
        class="u-showScrollBar"
        i18n-placeholder="@@hubConfigRolesBulkAddDrawer.textAreaPlaceholder"
      ></textarea>
    </mat-form-field>
  </form>
  <p
    class="color-grey-300 text-caption"
    i18n="@@hubConfigRolesBulkAddDrawer.warningText"
  >
    Duplicate items will not be added again.
  </p>
</ng-template>
<ng-template #review>
  <div class="u-marginBottom-24">
    <ng-container [formGroup]="rolesWithConfigs">
      <nz-table
        nzSize="small"
        [nzData]="['']"
        nzBordered
        nzTableLayout="fixed"
        nzShowPagination="false"
      >
        <thead>
          <tr>
            <th nzWidth="25%" i18n="@@hubConfigRolesBulkAddDrawer.titleRole">
              Role name
            </th>
            <th nzWidth="25%">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
              >
                <p i18n="@@global.titleReceivedIntroductions">Introductions</p>
                <mat-icon
                  nz-tooltip
                  nzTooltipTitle="Members who join with this role will be opted in to receive automated Introductions to other members. This can be changed by the member."
                  class="color-teal md-16"
                  nzTooltipPlacement="left"
                  i18n-nzTooltipTitle="
                    @@hubConfigRolesBulkAddDrawer.introductionTooltip"
                >
                  info_outline
                </mat-icon>
              </div>
            </th>
            <th nzWidth="20%">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
              >
                <p i18n="@@global.acceptInvitation">Messages</p>
                <mat-icon
                  nz-tooltip
                  nzTooltipTitle="Members who join with this role can receive messages from other members. This can be changed by the member."
                  class="color-teal md-16"
                  i18n-nzTooltipTitle="
                    @@hubConfigRolesBulkAddDrawer.messageTooltip"
                >
                  info_outline
                </mat-icon>
              </div>
            </th>
            <th nzWidth="20%">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="4px"
              >
                <p i18n="@@global.appearOnSearch">Search</p>
                <mat-icon
                  nz-tooltip
                  nzTooltipTitle="Members who join with this role can be searched by other members. This can be changed by the member."
                  class="color-teal md-16"
                  i18n-nzTooltipTitle="
                    @@hubConfigRolesBulkAddDrawer.searchTooltip"
                >
                  info_outline
                </mat-icon>
              </div>
            </th>
            <th nzWidth="10%" nzRight></th>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="roles">
            <tr
              *ngFor="let role of getRoleControls()?.controls; let i = index"
              [formGroupName]="i"
            >
              <td>
                {{ role.get('name').value }}
              </td>
              <td>
                <ng-container formGroupName="defaults">
                  <mat-slide-toggle
                    formControlName="opted_into_matchmaking"
                  ></mat-slide-toggle>
                </ng-container>
              </td>
              <td>
                <ng-container formGroupName="defaults">
                  <mat-slide-toggle
                    formControlName="inviteable"
                  ></mat-slide-toggle>
                </ng-container>
              </td>
              <td>
                <ng-container formGroupName="defaults">
                  <mat-slide-toggle
                    formControlName="searchable"
                  ></mat-slide-toggle>
                </ng-container>
              </td>
              <td>
                <button
                  mat-icon-button
                  aria-label="delete role"
                  i18n-aria-label="@@hubConfigRolesBulkAddDrawer.deleteRoleAria"
                  (click)="removeRow(i)"
                >
                  <mat-icon
                    class="md-18 color-grey-300 u-paddingBottom-24"
                    fontSet="material-icons-outlined"
                    >delete
                  </mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </ng-container>
  </div>
</ng-template>
<ng-template #summary>
  <div class="u-marginBottom-24">
    <p
      *ngIf="0 !== validOptions.length + invalidOptions.length"
      class="u-marginBottom-16"
      i18n="@@hubConfigRolesBulkAddDrawer.summary"
    >
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: validOptions }"
      ></ng-container>
      have been added successfully and
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: invalidOptions }"
      ></ng-container>
      had errors. Please see the summary below:
    </p>
    <nz-tabset>
      <nz-tab
        *ngIf="validOptions.length"
        nzTitle="Added ({{ validOptions.length }})"
        i18n-nzTitle="@@hubConfigRolesBulkAddDrawer.addedTab"
      >
        <nz-table
          #validOptionsData
          [nzData]="validOptions"
          nzSize="small"
          nzBordered
          [nzHideOnSinglePage]="true"
        >
          <thead>
            <tr>
              <th i18n="@@hubConfigRolesBulkAddDrawer.optionLabel">Option</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of validOptionsData.data">
              <td>{{ option.role?.name }}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
      <nz-tab
        *ngIf="invalidOptions.length"
        nzTitle="Errors ({{ invalidOptions.length }})"
        i18n-nzTitle="@@hubConfigRolesBulkAddDrawer.errorsTab"
      >
        <nz-table
          #invalidOptionsData
          [nzData]="invalidOptions"
          nzSize="small"
          nzBordered
          [nzHideOnSinglePage]="true"
        >
          <thead>
            <tr>
              <th i18n="@@hubConfigRolesBulkAddDrawer.optionLabel">Option</th>
              <th i18n="@@hubConfigRolesBulkAddDrawer.errorsLabel">
                What happened?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of invalidOptionsData.data">
              <td>
                {{ option.role?.name }}
              </td>
              <td>
                <span class="color-orange">{{ option.error }}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
    </nz-tabset>
  </div>
</ng-template>
<ng-template #optionPluralTemplate let-options>
  <ng-container
    i18n="@@hubConfigRolesBulkAddDrawer.optionPlural"
    >{options.length, plural,
      =1 {{{ options.length }} role}
      other {{{ options.length }} roles}

  }</ng-container>
</ng-template>
<ng-template #success>
  <div class="u-marginBottom-16">
    <p i18n="@@hubConfigRolesBulkAddDrawer.success">
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: validOptions }"
      ></ng-container>
      have been added.
    </p>
  </div>
</ng-template>
